<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('chargeTravailAff.popUpAffecter.title') }}
            </h1>
            <p class="has-text-default mgt-5">
              {{ $t('chargeTravailAff.popUpAffecter.' + (afficheurId && !unOtParFace
              ? 'sousTitleDateListe' : 'sousTitleAfficheur')) }}
            </p>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="message"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="columns is-multiline">
          <b-field class="column is-6 mgb-0 obligatoire"
                   :label="$t('chargeTravailAff.popUpAffecter.listeAfficheur')">
            <b-select v-model="afficheurId"
                      @input="removeTournee"
                      expanded>
              <option v-for="afficheur in allAfficheurs"
                      :key="afficheur.id"
                      :value="afficheur.id">
                {{ afficheur.nomCommercial }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-6 pdt-45px has-text-default">
            <b-checkbox v-model="unOtParFace" @input="updateOtParFace">
              {{ $t('chargeTravailAff.popUpAffecter.genererOtFace') }}
            </b-checkbox>
          </div>
          <b-field class="column is-6 obligatoire"
                   v-if="!unOtParFace && afficheurId"
                   :label="$t('chargeTravailAff.popUpAffecter.tourneeAffiche')">
            <b-autocomplete
              allow-new
              v-model="tourneeModele"
              :data="tournees"
              field="libelle"
              open-on-focus
              @typing="getTournees"
              :loading="isFetching"
              @select="tournee => selectTournee(tournee)">
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('chargeTravailAff.popUpAffecter.actions.noResult')}}
                </div>
                <div v-else>
                  {{$t('chargeTravailAff.popUpAffecter.actions.search')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
          <b-field class="column is-6 obligatoire"
                   v-if="agences.length > 1 && tourneeModeleId === null"
                   :label="$t('chargeTravailAff.popUpAffecter.agence')">
            <b-select v-model="agenceId"
                      expanded>
              <option></option>
              <option v-for="agence in agences"
                      :key="agence.agenceId"
                      :value="agence.agenceId">
                {{ agence.libelleAgence }}
              </option>
            </b-select>
          </b-field>
          <b-field class="column is-6 obligatoire is-height-320"
                   v-if="!unOtParFace && afficheurId"
                   :label="$t('chargeTravailAff.popUpAffecter.dateDepart')">
            <b-datepicker show-week-number
                          v-model="date"
                          :disabled="tourneeModeleId !== null"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          editable>
            </b-datepicker>
          </b-field>
        </div>
        <footer class="mgt-40px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$emit('close')">
                {{ $t('chargeTravailAff.popUpAffecter.actions.cancel') }}
              </a>
            </div>
            <div class="is-pulled-left boutonAction" @click="affecter()">
              <a class="button is-addOrEdit">
                {{ $t('chargeTravailAff.popUpAffecter.actions.affecter') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/logistique/tourneeModele';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { getAll as getAllTiers } from '@/api/tiers';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_AFFICHEUR,
} from '@/configuration/tiers/tiersConf';

const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  props: {
    infoBaseForAffectation: {
      type: Object,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    message: {
      type: Array,
      required: false,
    },
    anneeSemaine: {
      type: Number,
      required: true,
    },
    messagesChampsVide: {
      type: Array,
      required: false,
    },
    champsVide: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      tourneeModele: null,
      tournees: [],
      isFetching: false,
      tourneeModeleId: null,
      afficheurId: null,
      date: null,
      allAfficheurs: [],
      unOtParFace: false,
      OtId: null,
      agenceId: null,
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    agences() {
      return this.user.agences.filter((agence) => {
        return agence.societeId === this.societeActiveId;
      });
    },
  },
  methods: {
    updateOtParFace(valueOtParFace) {
      this.unOtParFace = valueOtParFace;
      if (valueOtParFace) {
        this.date = null;
        this.removeTournee();
      }
    },
    removeTournee() {
      this.tourneeModeleId = null;
      this.tourneeModele = null;
      this.otId = null;
      this.getTournees();
    },
    selectTournee(tournee) {
      if (!tournee) return;
      this.tourneeModele = tournee.libelle;
      this.tourneeModeleId = tournee.id;
      this.agenceId = tournee.agenceId;
      if (tournee.id) {
        this.date = moment(this.anneeSemaine, 'GGGGWW')
          .weekday(tournee.jourDepart).toDate();
      }
    },
    getTournees: debounce(async function tourneesData(search) {
      this.tournees = [];
      this.isFetching = true;
      this.tourneeModeleId = null;
      this.tournees = (await getAll({
        query: {
          libelle: search,
          societeId: this.societeActiveId,
          afficheurId: this.afficheurId,
          actif: true,
        },
        limit: NO_PAGINATION,
      })).data.result.items;
      this.isFetching = false;
    }, 500),
    affecter() {
      this.$emit('affectation', {
        tourneeId: this.tourneeModeleId,
        tourneeLibelle: this.tourneeModele,
        afficheurId: this.afficheurId,
        date: this.date,
        unOtParFace: this.unOtParFace,
        agenceId: this.agenceId,
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.allAfficheurs = (await getAllTiers({
        query: {
          type: TIERS_TYPE_FOURNISSEUR,
          archive: false,
          sousType: [TIERS_SOUS_TYPE_AFFICHEUR],
          societeId: this.societeActiveId,
        },
        limit: NO_PAGINATION,
      })).data.result.items;
      await this.getTournees();
      this.otId = this.infoBaseForAffectation.otId;
      this.afficheurId = this.infoBaseForAffectation.afficheurId;
      this.date = this.infoBaseForAffectation.date
        ? new Date(this.infoBaseForAffectation.date) : null;
      this.tourneeModele = this.infoBaseForAffectation.tourneeLibelle;
      if (this.agences.length === 1) this.agenceId = this.agences[0].agenceId;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
